export interface IBaseFilterParameter {
  $sort?: {
    updatedAt?: number;
    createdAt?: number;
  }
  $skip?: number;
  state?: string[] | number[]
  // state?: { $in?: string[] }
  $limit?: number;
  orderKeys?: string[];
  orderValues?: number[];
}
export class BaseFilterParameter {
  /**
   *
   */
  orderKeys?: string[];
  orderValues?: number[];
  $skip?: number;
  $sort: {
    updatedAt: number;
    createdAt?: number;
  }
  state: string[] | number[]
  $limit?: number;
  constructor(opt: IBaseFilterParameter = {}) {
    this.state = opt.state;
    this.$limit = opt.$limit || 10;
    this.orderKeys = opt.orderKeys || ['updatedAt', 'createdAt'];
    this.orderValues = opt.orderValues || [-1, -1];
    this.$skip = 0;
  }
}


// WEBPACK FOOTER //
// ./src/models/base-filter.parameter.ts